


// import React, { useRef, useState } from "react";
// import {
//   Box,
//   Button,
//   CircularProgress,
//   IconButton,
//   FormControl,
// } from "@mui/material";
// import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import { Controller } from "react-hook-form";
// import axios from "axios";
// import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";

// export default function FileUploaderNew({
//   name,
//   label,
//   hasLabel = true,
//   isMandatory = false,
//   validationMsg ,
//   maxFiles = 5,
//   tab,
//   uploadedDocs = [],
//   setUploadedDocs = () => {},
//   control,
//   required = false,
//   showError = false,
// }) {
//   const fileInputRef = useRef();
//   const [isLoading, setIsLoading] = useState(false);
//   const [isPreviewLoading, setIsPreviewLoading] = useState(false);
//   const [showToast, setShowToast] = useState(null);

//   const handleFileUpload = async (e, inputName = name || "fileInput") => {
//     const files = Array.from(e.target.files);
//     setIsLoading(true);
//     setShowToast(null);

//     const alreadyUploaded = uploadedDocs?.filter(doc => doc.documentType === inputName)?.length || 0;
//     const filesToUpload = files.slice(0, maxFiles - alreadyUploaded);

//     const allowedExtensionsByTab = {
//       1: [".pdf"],
//       2: [".png", ".jpg", ".jpeg"],
//       3: [".dxf"],
//       5: [".dxf"],
//       6: [".mp4", ".mov", ".avi", ".mkv"], // 🔹 Video formats
//     };

//     const maxSizeByTab = {
//       1: 10 * 1024 * 1024,
//       2: 10 * 1024 * 1024,
//       3: 100 * 1024 * 1024,
//       5: 100 * 1024 * 1024,
//       6: 50 * 1024 * 1024, // 🔹 50MB for videos
//       default: 30 * 1024 * 1024,
//     };


//     const allowedExtensions = allowedExtensionsByTab[tab] || [".pdf"];
//     const maxSize = maxSizeByTab[tab] || maxSizeByTab.default;

//     for (let file of filesToUpload) {
//       const ext = "." + file.name.split(".").pop().toLowerCase();

//       if (!allowedExtensions.includes(ext)) {
//         setShowToast({ error: true, label: `Invalid format: ${file.name}` });
//         continue;
//       }

//       if (file.size > maxSize) {
//         setShowToast({ error: true, label: `${file.name} exceeds ${maxSize / 1024 / 1024} MB.` });
//         continue;
//       }

//       const formData = new FormData();
//       formData.append("file", file);
//       formData.append("tenantId", "up");
//       formData.append("module", "property-upload");
//       formData.append("tag", "tag-property");

//       try {
//         const resp = await axios.post("/filestore/v1/files", formData, {});
//         const filesId = resp.data.files[0];

//         setUploadedDocs(prev => [
//           ...prev,
//           {
//             documentType: inputName,
//             fileStoreId: filesId.fileStoreId,
//             additionalDetails: { fileName: file.name, title: label },
//           },
//         ]);
//       } catch (err) {
//         console.error(err.message);
//         setShowToast({ error: true, label: `Upload failed for ${file.name}` });
//       }
//     }

//     setIsLoading(false);
//     e.target.value = null;
//   };

//   const handleDelete = (fileStoreId) => {
//     setUploadedDocs((prev) => prev.filter((doc) => doc.fileStoreId !== fileStoreId));
//   };

//   const docsForThisType = uploadedDocs?.filter((doc) => doc.documentType === (name || "fileInput"));

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column" }}>
//       {hasLabel && (
//         <h3 className="label" style={{ width: "100%" }}>
//           {label}
//           {isMandatory && <span className="compulsoryField"> *</span>}
//         </h3>
//       )}

//       <FormControl fullWidth>
//         <Button
//           variant="outlined"
//           component="span"
//           onClick={() => fileInputRef.current.click()}
//           sx={{
//             width: "100%",
//             mb: 1,
//             height: "30px",
//             backgroundColor: "rgb(21, 124, 179)",
//             color: "white",
//             "&:hover": { backgroundColor: "#004e6c", color: "#fff" },
//           }}
//           disabled={docsForThisType.length >= maxFiles}
//         >
//           {isLoading ? (
//             <CircularProgress sx={{ color: "#fff" }} size={24} />
//           ) : (
//             <React.Fragment>
//               <CloudUploadOutlinedIcon />
//               <span style={{ marginLeft: "0.5em", fontSize: "0.7rem" }}>{validationMsg}</span>
//             </React.Fragment>
//           )}
//         </Button>

//         {/* Unified Input logic */}
//         {control && name ? (
//           <Controller
//             name={name}
//             control={control}
//             rules={{
//               required: required && docsForThisType.length === 0,
//             }}
//             render={({ field }) => (
//               <input
//                 {...field}
//                 ref={fileInputRef}
//                 type="file"
//                 multiple
//                 style={{ display: "none" }}
//                 onChange={(e) => handleFileUpload(e, name)}
//               />
//             )}
//           />
//         ) : (
//           <input
//             ref={fileInputRef}
//             type="file"
//             multiple
//             style={{ display: "none" }}
//             onChange={(e) => handleFileUpload(e)}
//           />
//         )}
//       </FormControl>

//       {/* Uploaded Docs List */}
//       {docsForThisType.length > 0 && (
//         <Box sx={{ mt: 1 }}>
//           {docsForThisType.map((doc) => (
//             <Box
//               key={doc.fileStoreId}
//               sx={{
//                 backgroundColor: "#eee",
//                 borderRadius: "4px",
//                 padding: "4px 8px",
//                 marginBottom: "6px",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 fontSize: "0.7rem",
//               }}
//             >
//               {doc.additionalDetails?.fileName || doc.documentType}
//               <Box>
//                 <IconButton
//                   size="small"
//                   onClick={() => getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)}
//                 >
//                   {isPreviewLoading ? <CircularProgress size={16} /> : <VisibilityIcon fontSize="small" />}
//                 </IconButton>
//                 <IconButton size="small" onClick={() => handleDelete(doc.fileStoreId)}>
//                   <DeleteForeverIcon fontSize="small" color="error" />
//                 </IconButton>
//               </Box>
//             </Box>
//           ))}
//         </Box>
//       )}

//       {/* Errors */}
//       {required && showError && docsForThisType.length === 0 && (
//         <span className="errorText">{`${label || "This"} document is required.`}</span>
//       )}
//       {!!showToast?.error && <span className="errorText">{showToast.label}</span>}
//     </Box>
//   );
// }
import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  FormControl,
} from "@mui/material";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Controller } from "react-hook-form";
import axios from "axios";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";

export default function FileUploaderNew({
  name,
  label,
  hasLabel = true,
  isMandatory = false,
  validationMsg,
  maxFiles = 5,
  tab,
  uploadedDocs = [],
  setUploadedDocs = () => { },
  control,
  required = false,
  showError = false,
}) {
  const fileInputRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);

  const handleFileUpload = async (e, inputName = name || "fileInput") => {
    const files = Array.from(e.target.files);
    setIsLoading(true);
    setShowToast(null);

    const alreadyUploaded = uploadedDocs?.filter(
      (doc) => doc.documentType === inputName
    )?.length || 0;

    const filesToUpload = files.slice(0, maxFiles - alreadyUploaded);

    const allowedExtensionsByTab = {
      1: [".pdf"],
      2: [".png", ".jpg", ".jpeg", ".pdf"],
      3: [".dxf"],
      5: [".dxf"],
      6: [".mp4", ".mov", ".avi", ".mkv"], // 🔹 Video extensions
    };

    const maxSizeByTab = {
      1: 10 * 1024 * 1024,
      2: 30 * 1024 * 1024,
      3: 100 * 1024 * 1024,
      5: 100 * 1024 * 1024,
      6: 50 * 1024 * 1024, // 🔹 50MB for videos
      default: 30 * 1024 * 1024,
    };

    const allowedExtensions = allowedExtensionsByTab[tab] || [".pdf"];
    const maxSize = maxSizeByTab[tab] || maxSizeByTab.default;

    for (let file of filesToUpload) {
      const ext = "." + file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(ext)) {
        setShowToast({ error: true, label: `Invalid format: ${file.name}` });
        continue;
      }

      if (file.size > maxSize) {
        setShowToast({
          error: true,
          label: `${file.name} exceeds ${maxSize / 1024 / 1024} MB.`,
        });
        continue;
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("tenantId", "up");
      formData.append("module", "property-upload");
      formData.append("tag", "tag-property");

      try {
        const resp = await axios.post("/filestore/v1/files", formData, {});
        const filesId = resp.data.files[0];

        setUploadedDocs((prev) => [
          ...prev,
          {
            documentType: inputName,
            fileStoreId: filesId.fileStoreId,
            additionalDetails: { fileName: file.name, title: label },
          },
        ]);
      } catch (err) {
        console.error(err.message);
        setShowToast({
          error: true,
          label: `Upload failed for ${file.name}`,
        });
      }
    }

    setIsLoading(false);
    e.target.value = null;
  };

  const handleDelete = (fileStoreId) => {
    setUploadedDocs((prev) =>
      prev.filter((doc) => doc.fileStoreId !== fileStoreId)
    );
  };

  const docsForThisType = uploadedDocs?.filter(
    (doc) => doc.documentType === (name || "fileInput")
  );

  const getAcceptType = () => {
    switch (tab) {
      case 1:
        return ".pdf";
      case 2:
        return ".png,.jpg,.jpeg, .pdf";
      case 3:
      case 5:
        return ".dxf";
      case 6:
        return ".mp4,.mov,.avi,.mkv";
      default:
        return "*";
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      {hasLabel && (
        <h3 className="label" style={{ width: "100%" }}>
          {label}
          {isMandatory && <span className="compulsoryField"> *</span>}
        </h3>
      )}

      <FormControl fullWidth>
        <Button
          variant="outlined"
          component="span"
          onClick={() => fileInputRef.current.click()}
          sx={{
            width: "100%",
            mb: 1,
            height: "30px",
            backgroundColor: "rgb(21, 124, 179)",
            color: "white",
            "&:hover": { backgroundColor: "#004e6c", color: "#fff" },
          }}
          disabled={docsForThisType.length >= maxFiles}
        >
          {isLoading ? (
            <CircularProgress sx={{ color: "#fff" }} size={24} />
          ) : (
            <React.Fragment>
              <CloudUploadOutlinedIcon />
              <span style={{ marginLeft: "0.5em", fontSize: "0.7rem" }}>
                {validationMsg}
              </span>
            </React.Fragment>
          )}
        </Button>

        {/* Input controlled via react-hook-form or fallback */}
        {control && name ? (
          <Controller
            name={name}
            control={control}
            rules={{
              required: required && docsForThisType.length === 0,
            }}
            render={({ field }) => (
              <input
                {...field}
                ref={fileInputRef}
                type="file"
                multiple
                accept={getAcceptType()}
                style={{ display: "none" }}
                onChange={(e) => handleFileUpload(e, name)}
              />
            )}
          />
        ) : (
          <input
            ref={fileInputRef}
            type="file"
            multiple
            accept={getAcceptType()}
            style={{ display: "none" }}
            onChange={(e) => handleFileUpload(e)}
          />
        )}
      </FormControl>

      {/* Uploaded files list */}
      {docsForThisType.length > 0 && (
        <Box sx={{ mt: 1 }}>
          {docsForThisType.map((doc) => (
            <Box
              key={doc.fileStoreId}
              sx={{
                backgroundColor: "#eee",
                borderRadius: "4px",
                padding: "4px 8px",
                marginBottom: "6px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "0.7rem",
              }}
            >
              {doc.additionalDetails?.fileName || doc.documentType}
              <Box>
                <IconButton
                  size="small"
                  onClick={() =>
                    getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)
                  }
                >
                  {isPreviewLoading ? (
                    <CircularProgress size={16} />
                  ) : (
                    <VisibilityIcon fontSize="small" />
                  )}
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => handleDelete(doc.fileStoreId)}
                >
                  <DeleteForeverIcon fontSize="small" color="error" />
                </IconButton>
              </Box>
            </Box>
          ))}
        </Box>
      )}

      {/* Errors */}
      {required && showError && docsForThisType.length === 0 && (
        <span className="errorText">
          {`${label || "This"} document is required.`}
        </span>
      )}
      {!!showToast?.error && (
        <span className="errorText">{showToast.label}</span>
      )}
    </Box>
  );
}
